import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import Cookies from 'js-cookie';

export default class HttpClient {
  private static axiosInstance?: AxiosInstance;

  private static initializeAxiosInstance(): void {
    HttpClient.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_API ?? '',
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    HttpClient.setupInterceptors();
  }

  private static setupInterceptors(): void {
    HttpClient.axiosInstance.interceptors.request.use(
      (config) => {
        const token = Cookies.get('jwt');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
      },
      (error) => Promise.reject(error)
    );

    HttpClient.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Global error handling
        return Promise.reject(error);
      }
    );
  }

  static async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    if (!HttpClient.axiosInstance) HttpClient.initializeAxiosInstance();
    const response: AxiosResponse<T> = await HttpClient.axiosInstance.get(url, config);
    return response.data;
  }

  static async post<T, D = Record<string, unknown>>(url: string, data?: D, config?: AxiosRequestConfig): Promise<T> {
    if (!HttpClient.axiosInstance) HttpClient.initializeAxiosInstance();
    const response: AxiosResponse<T> = await HttpClient.axiosInstance.post(url, data, config);
    return response.data;
  }

  static async put<T, D = Record<string, unknown>>(url: string, data?: D, config?: AxiosRequestConfig): Promise<T> {
    if (!HttpClient.axiosInstance) HttpClient.initializeAxiosInstance();
    const response: AxiosResponse<T> = await HttpClient.axiosInstance.put(url, data, config);
    return response.data;
  }

  static async patch<T, D = Record<string, unknown>>(url: string, data?: D, config?: AxiosRequestConfig): Promise<T> {
    if (!HttpClient.axiosInstance) HttpClient.initializeAxiosInstance();
    const response: AxiosResponse<T> = await HttpClient.axiosInstance.patch(url, data, config);
    return response.data;
  }

  static async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    if (!HttpClient.axiosInstance) HttpClient.initializeAxiosInstance();
    const response: AxiosResponse<T> = await HttpClient.axiosInstance.delete(url, config);
    return response.data;
  }
}
